import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class PaymentQueryService {

    public GET_PAYEMNT: any;
    public CREATE_PAYMENT: any

    constructor(public apollo: Apollo) {

        /* To create payment */
        this.CREATE_PAYMENT = gql` 
          mutation CREATE_PAYMENT($input: CreatePaymentInput!) {
            createPayment(input: $input) {
                payment{
                    userid
                 }
            }
           }
        `;

        this.GET_PAYEMNT =
            gql`
            query getPaymentValue($userid:UUID!){                           
                allPayments (condition: {userid:$userid} ){
                    edges {
                        node {
                        cusid
                        sourceid
                        }
                    }
                }
              }
        `
    }

    /* To create user */
    CREATE_PAYMENT_INFO(cusId, sourceId): any {

        return this.apollo.mutate({
            mutation: this.CREATE_PAYMENT,
            variables: {
                "input": {
                    "payment": {
                        "cusid": cusId,
                        "sourceid": sourceId,
                        "userid": window.localStorage.getItem('userUID'),
                    }
                }
            }
        })
    }

    //get charge percentage
    GET_PAYMENT_INFO() {

        return this.apollo
            .watchQuery({
                query: this.GET_PAYEMNT
                ,
                variables:
                {
                    "userid": window.localStorage.getItem('userUID'),
                },
                fetchPolicy: 'network-only'
            });
    }
}


// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/gql-query-mutation/payment.ts